import React, { useContext } from 'react';
import { MyPortfolioCapsuleContentProps } from 'widgets/myPortfolioCapsules/MyPortfolioCapsuleWidgetStrategy';
import { useSymbolTileStreamData } from 'widgets/symbolTile/store/data/hooks';
import { buildSymbolTileData } from 'widgets/symbolTile/components/symbolTileData';
import { SymbolTileConfigState } from 'widgets/symbolTile/store/instances/config/SymbolTileConfigState';
import { SymbolTileContent } from 'widgets/symbolTile/components/SymbolTileContent';
import { useMyPortfolioCapsuleConfigSlice } from 'widgets/myPortfolioCapsules/store/config/configSlice';
import AppContext from 'app/AppContext';
import {
    useSymbolExternalMarketData,
    useSymbolExternalMarketDataLatestTick,
} from 'marketData/hooks';

export function SymbolTileMyPortfolioCapsuleContent(
    props: MyPortfolioCapsuleContentProps
) {
    const { symbol, symbology } = props;
    const { config, dispatchConfigChanged } =
        useMyPortfolioCapsuleConfigSlice<SymbolTileConfigState>();
    const { numberFormat } = useContext(AppContext);

    const { showDataFor } = config;

    const streamData = useSymbolTileStreamData(symbol);
    const { barData } = useSymbolExternalMarketData(symbol, symbology, 1);
    const externalMarketDataLatestTick = useSymbolExternalMarketDataLatestTick(
        symbol,
        symbology
    );

    const data = buildSymbolTileData(
        numberFormat,
        streamData,
        barData,
        externalMarketDataLatestTick,
        showDataFor
    );

    return (
        <SymbolTileContent
            data={data}
            config={config}
            dispatchConfigChanged={dispatchConfigChanged}
        />
    );
}
